
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/marketplace/partnership",
      function () {
        return require("private-next-pages/[locale]/marketplace/partnership.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/marketplace/partnership"])
      });
    }
  